













































import Vue from 'vue';
import Create from './components/Create.vue'
import Notes from './components/Notes.vue'
import NoteModal from './components/NoteModal.vue'

export default Vue.extend({
  name: 'App',

  components: {
    Create,
    Notes,
    NoteModal
  },

  data: () => ({
    loading: false,
    refreshLoading: false
  }),
  methods: {
    async refresh(){
      this.refreshLoading = true
      await this.$store.dispatch('notes/getNotes')
      this.refreshLoading = false
    }
  },
  computed: {
    snackbar(){
      return this.$store.getters['global/showSnackbar']
    }
  },
  async created() {
      this.loading = true
      await this.$store.dispatch('notes/getNotes')
      this.loading = false
  }
});
